import { HQAccount } from '../models';

// acsProject was the original legacy permission for acc access, accEliglble is the new permission for acc access
// there is a large overlap between the two

// A project admin creation permission can either be:
// - an acsProjectAdmin (which is a user that is a project admin on at least 1 acs project in that account)
// - a project admin (a user on at least 1 project in the account) and the account is accEligible
// Additionally, if createProjectAccessLevels is present for the account, projectAdmin must be present on that array
const hasProjectAdminCreationPermissions = (account: HQAccount): boolean =>
  // NOTE: account.accessLevels is null if the user is not a member of any projects in the account
  account.accessLevels
    ? (account.accessLevels.acsProjectAdmin ||
        (account.accessLevels.projectAdmin && account.isAccEligible)) &&
      (!account.createProjectAccessLevels ||
        account.createProjectAccessLevels.includes('projectAdmin'))
    : false;

// An account admin creation permission can either be an account admin on an account that:
// - hasAcsUnifiedProjects (i.e. at least 1 acs project)
// - isAccEligible (i.e. acc has been enabled for the account)
// Additionally, if createProjectAccessLevels is present for the account, accountAdmin must be present on that array
const hasAccountAdminCreationPermissions = (account: HQAccount): boolean =>
  account.accessLevels
    ? account.accessLevels.accountAdmin &&
      (account.hasAcsUnifiedProjects || account.isAccEligible) &&
      (!account.createProjectAccessLevels ||
        account.createProjectAccessLevels.includes('accountAdmin'))
    : false;

export const filterAccountsWithoutCreation = (
  accounts: HQAccount[],
): HQAccount[] =>
  accounts.filter(
    (account) =>
      hasAccountAdminCreationPermissions(account) ||
      hasProjectAdminCreationPermissions(account),
  );

export const filterNonAccAccountAdminAccounts = (
  accounts: HQAccount[],
): HQAccount[] =>
  accounts.filter(
    (account) =>
      account.accessLevels &&
      account.accessLevels.accountAdmin &&
      account.isAccEligible,
  );

export const filterNonExecutiveAccounts = (
  accounts: HQAccount[],
): HQAccount[] =>
  accounts.filter(
    (account) => account.accessLevels && account.accessLevels.executive,
  );

export const filterAccAccountsByAllowlist = (
  accounts: HQAccount[],
  allowAccountIds: string[],
): HQAccount[] =>
  accounts.filter(
    (account) => account.isAccEligible && allowAccountIds.includes(account.id),
  );
